import { LabelVariant, Label } from '@workwhile/ui'
import { toTitleCase } from 'lib/string'
import React from 'react'

export const ShiftStatusRender = ({ value }: { value: string }) => {
  const getStatusVariant = (status: string): LabelVariant => {
    switch (status.toLowerCase()) {
      case 'approved':
      case 'employer_approved':
      case 'paid':
        return 'success'
      case 'completed':
        return 'information'
      case 'admin_review':
      case 'employer_review':
        return 'warning'
      case 'bailed':
      case 'rejected':
      case 'employer_cancelled':
        return 'error'
      default:
        return 'neutral'
    }
  }

  const variant = getStatusVariant(value)

  return (
    <Label variant={variant} size="small" style={{ whiteSpace: 'nowrap' }}>
      {toTitleCase(value.toLowerCase().replace(/_/g, ' '))}
    </Label>
  )
}
